import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

declare var ga: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      // if(event instanceof NavigationStart){
      //   if(this.checkFullPageNavigation(event)){
      //     const currentRoute = this.router.routerState;
      //     console.log(currentRoute.snapshot.url)
      //     this.router.navigateByUrl(currentRoute.snapshot.url, { skipLocationChange: true });
      //   }
      // }
     if (event instanceof NavigationEnd) {
       ga('set', 'page', event.urlAfterRedirects);
       ga('send', 'pageview');
     }
   });
 }


  title = 'WorkmateWeb';

  ngOnInit(){
    // this.jsonp('http://10.10.21.153:8080/rev-geocode-1.0.0.0/places/rev_geocode?lat=28.5507160000001&lng=77.2689280000001&access_token=815562b7-2b09-4b96-9a08-85aa8284e8ee', function(data) {
    //   console.log(data);
    //   alert(JSON.stringify(data));
    // });
  }

  // jsonp(url, callback) {
  //   const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
  //   const script = document.createElement('script');
  //   script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
  //   document.body.appendChild(script);
  //   window[callbackName] = function(data) {
  //   delete window[callbackName];
  //   document.body.removeChild( script );
  //   callback(data);
  //   };
  // }

  checkFullPageNavigation(event){
    if(["/get-started#firstPage1", "/get-started#firstPage2", 
    "/get-started#firstPage3", "/get-started#secondPage", 
    "/get-started#3rdPage"].includes(event.url)){
      return true;
    }
    return false;
  }
}
